import useRequest from "@/utils/useCrypRequest";
import {
  UserInfoInterface,
  CheckThirdLoginParamsInterface,
  ThirdLoginParamsInterface,
} from "@/interface/user";

interface EmailRegisterBody {
  email: string;
  password: string;
  source?: number;
}
interface CheckEmailRegisterData {
  email: string;
  type: number;
}
interface CheckValidateCodeData {
  email: string;
  code: string;
  type: number;
}
// 邮箱注册
export const emailRegister = (body: EmailRegisterBody) => {
  return useRequest.post("/quan/h5/user/email/register", body, {
    loading: true,
    transform(result: any) {
      return result.data;
    },
  });
};
// 验证邮箱是否已注册
export const checkEmailRegister = (data: CheckEmailRegisterData) => {
  return useRequest.post("/quan/h5/user/email/validateIsRegister", data, {
    loading: true,
    transform(result: any) {
      return result.data;
    },
  });
};

// 发送验证码
export const sendValidateCode = (data: CheckEmailRegisterData) => {
  return useRequest.post("/quan/h5/user/email/sendValidateCode", data, {
    loading: true,
  });
};

// 校验验证码
export const checkValidateCode = (data: CheckValidateCodeData) => {
  return useRequest.post("/quan/h5/user/email/checkValidateCode", data, {
    loading: true,
    transform(result: any) {
      return result;
    },
  });
};
// 重置密码
export const resetPassword = (data: EmailRegisterBody) => {
  return useRequest.post("/quan/h5/user/email/resetPassword", data, {
    loading: true,
  });
};
// 登录
export const login = (data: EmailRegisterBody) => {
  return useRequest.post("/quan/h5/user/email/login", data, {
    loading: true,
    transform(result: any) {
      return result || {};
    },
    checkLogin: true,
  });
};
// token续期
export const renewalToken = () => {
  return useRequest.get("/quan/h5/user/token/renewalToken", null, {
    skipLoginModal: true,
    checkLogin: true,
  });
};
// 获取用户信息
export const queryUserInfo = () => {
  return useRequest.get("/quan/h5/user/getUserInfo", null, {
    transform(result: { data: UserInfoInterface }) {
      return result.data || {};
    },
  });
};
// 第三方登录校验
export const checkThirdLogin = (data: CheckThirdLoginParamsInterface) => {
  return useRequest.post("/quan/h5/user/third/checkLogin", data, {
    loading: true,
    skipLoginModal: true,
    transform(result: { code: string; data: UserInfoInterface }) {
      return result;
    },
  });
};
// 第三方登录
export const thirdLogin = (data: ThirdLoginParamsInterface) => {
  return useRequest.post("/quan/h5/user/third/login", data, {
    loading: true,
    transform(result: { code: string; data: UserInfoInterface }) {
      return result;
    },
  });
};

// 使用google accesstoken
export const googleCheckoutLogin = (
  data: Omit<ThirdLoginParamsInterface, "password">
) => {
  return useRequest.post("/quan/h5/user/third/access/checkAndLogin", data, {
    loading: true,
    transform(result: { code: string; data: UserInfoInterface }) {
      return result;
    },
  });
};
